import React, { useEffect, useState, useSyncExternalStore } from "react";
import { Spin } from "antd";
import axios from "axios";
import "./style.css";

let pendingRequests = 0;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => pendingRequests;

const startRequest = (config) => {
  if (config?.skipLoader) return config;
  config.__countedByLoader = true;
  pendingRequests += 1;
  notify();
  return config;
};

const endRequest = (config) => {
  if (!config?.__countedByLoader) return;
  config.__countedByLoader = false;
  pendingRequests = Math.max(0, pendingRequests - 1);
  notify();
};

axios.interceptors.request.use(startRequest, (error) => {
  endRequest(error?.config);
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => {
    endRequest(response?.config);
    return response;
  },
  (error) => {
    endRequest(error?.config);
    return Promise.reject(error);
  },
);

const GlobalLoader = ({ delay = 150 }) => {
  const pending = useSyncExternalStore(subscribe, getSnapshot);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pending > 0) {
      const timer = setTimeout(() => setVisible(true), delay);
      return () => clearTimeout(timer);
    }
    setVisible(false);
  }, [pending, delay]);

  if (!visible) return null;

  return (
    <div className="global-loader-overlay">
      <Spin size="large" />
    </div>
  );
};

export default GlobalLoader;
